import React from 'react';
import Layout from '../components/layout';
import Image from '../components/image';
import './digital-signage.css';

export default function DigitalSignagePage() {
  return (
    <Layout
      subtitle="Digital Signage and Video Walls"
      className="Signage smart-power-theater"
    >
      <Image
        src="signage/Times Square_2_with_text.png"
        style={{ marginBottom: '1.5rem' }}
      />

      <p>
        Digital signage is omnipresent throughout our entire lives today.
        Whether it is arrival or departure messaging at airports, billboards on
        streets and highways, scoreboards and message boards employed at sports
        venues, backdrops for live stage and concert presentations, or
        spectaculars on our city streets, every sign’s purpose is to enhance the
        interaction of sharing messages to the viewer or customers.
      </p>
      <p>
        If any element in the digital array has failed, the viewers’ attention
        instinctively is attracted to the failed element and the entire purpose
        for the intended message is lost - resulting in a complete failure of
        the purpose for the particular digital sign. It might be missing flight
        information, or the video displaying of you and your child while
        attending a sporting event, or the advertisement message, or the
        background ambience creation on a live stage presentation - all
        resulting in the failure to effectively communicate the message to the
        viewer.
      </p>
      <section style={{ display: 'flex', marginBottom: '1.5rem' }}>
        <Image src="signage/Airport_1.JPG" style={{ width: '33.3%' }} />
        <Image src="signage/Stadium_1.JPG" style={{ width: '33.3%' }} />
        <Image src="signage/Stage_1.JPG" style={{ width: '33.3%' }} />
      </section>
      <p>
        Benjamin Smart Power panels offer multiple enhancements to the power
        distribution system that provides significant benefits towards both
        minimizing these failures as well as proactive response to inevitable
        hardware breakdowns.
      </p>
      <ul>
        <li>
          Effective AC Power Sequencing to minimize the impacts from startup
          loads, thereby extending the lifespan of the array elements.
        </li>
        <li>
          Controlled power distribution to cycle power to reduce energy usage
          and extend the lifespan of the array elements.
        </li>
        <li>
          Smart load monitoring to provide immediate notification when a failed
          element is detected for response dispatch.
        </li>
        <li>
          Optional embedded surge protection to protect the loads from within
          the supporting power sources.
        </li>
      </ul>
      <p>
        <a className="contact-us" href="/contact">
          <button>Contact Us</button>
        </a>
      </p>
    </Layout>
  );
}
